import { render, staticRenderFns } from "./RaffleJoin.vue?vue&type=template&id=2f070b4b&scoped=true&"
import script from "./RaffleJoin.vue?vue&type=script&lang=js&"
export * from "./RaffleJoin.vue?vue&type=script&lang=js&"
import style0 from "./RaffleJoin.vue?vue&type=style&index=0&id=2f070b4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f070b4b",
  null
  
)

export default component.exports